import React from 'react';
import Cookies from 'js-cookie';

const Welcome = (props) => {
  const nickName = Cookies.get('CLS_SNAIL_CUSTOMER_CMS_NICKNAME');

  return (
    <div className="d-f f-c-c welcome-box">
      <div className="t-a-c">
        <div>
          <img className="welcome-image" src="/welcome.png" />
        </div>
        <div className="f-s-36 l-h-138889 c-222 welcome-nickname">您好，{nickName}</div>
        <div className="f-s-28 l-h-142857 c-222">{props.isLoadingWelcome ? '蜗牛 在努力加载资源中...' : '欢迎使用蜗牛内容上传平台！'}</div>
      </div>
    </div>
  );
};

export default Welcome;
